import React from "react";
import {Nav} from "react-bootstrap";
import {observer} from "mobx-react";
import {useLocation} from "react-router-dom";
import rootStore from "../stores/rootStore.js";

function AdminNav({compact = false}){
    const location = useLocation();
    const navItems = [
        {href: "/admin/taxAuth", label: "Tax Authorities", icon: "bi-building-gear"},
        {href: "/admin/orders", label: "Orders", icon: "bi-receipt"},
        {href: "/admin/reports", label: "Reports", icon: "bi-bar-chart"},
        {href: "/admin/products", label: "Products", icon: "bi-box-seam"}
    ];
    const accountItems = [
        {href: "/account", label: "Profile", icon: "bi-person-circle"}
    ];

    const isActive = (href) => location.pathname.startsWith(href);
    const handleLogout = () => {
        rootStore.authenticationStore.logout();
    };

    return (
        <Nav className={`flex-column nav-panel ${compact ? "nav-compact" : ""}`} data-accent="admin">
            <div className="nav-title">Admin Console</div>
            {navItems.map((item) => (
                <Nav.Link key={item.href} href={item.href} active={isActive(item.href)}>
                    <span className="nav-icon"><i className={`bi ${item.icon}`}></i></span>
                    {!compact && <span>{item.label}</span>}
                </Nav.Link>
            ))}
            <div className="nav-divider"></div>
            {accountItems.map((item) => (
                <Nav.Link key={item.href} href={item.href} active={isActive(item.href)}>
                    <span className="nav-icon"><i className={`bi ${item.icon}`}></i></span>
                    {!compact && <span>{item.label}</span>}
                </Nav.Link>
            ))}
            <Nav.Link href="/login" onClick={handleLogout}>
                <span className="nav-icon"><i className="bi bi-box-arrow-right"></i></span>
                {!compact && <span>Log off</span>}
            </Nav.Link>
        </Nav>
    )
}

export default observer(AdminNav);
